<template>
  <BaseView title="Weather Routing">
    <template #content>
      <div
        class="d-flex"
        style="height: 100%; overflow: hidden; position: relative"
      >
        <v-container
          style="
            height: 100%;
            max-height: 100%;
            position: absolute;
            width: 34em;
            padding: 0px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          "
        >
          <router-view />
        </v-container>

        <div
          class="flex-grow-1"
          style="position: absolute; right: 0; bottom: 0; top: 0; left: 34em"
        >
          <LayerMap />
        </div>
      </div>
    </template>
  </BaseView>
</template>

<script>
import { mapActions } from "vuex";
import LayerMap from "./map/View.vue";
import BaseView from "../components/BaseView.vue";

export default {
  name: "WeatherRoutingView",
  components: { LayerMap, BaseView },
  data: function () {
    return {};
  },
  watch: {
    async $route(to, from) {
      const fromVesselName = from.params.vessel;
      const toVesselName = to.params.vessel;
      if (fromVesselName !== toVesselName) {
        await this.fetchVesselData(toVesselName);
        await this.fetchInitialData();
      }
    },
  },
  async created() {
    await this.initializeData();
  },
  methods: {
    ...mapActions("weatherRouting", ["fetchInitialData", "fetchVesselData"]),
    async initializeData() {
      const vesselName = this.$route.params.vessel;
      await this.$store.dispatch("weatherRouting/postAuthentication");
      await this.fetchVesselData(vesselName);
      await this.fetchInitialData();
    },
  },
};
</script>

<style scoped>
</style>
